import axios from 'axios'
import config from './config'
import _ from 'lodash'

class Api {
    static _toko = null
    static daftar_toko = []

    static getThumb2Url(fotoId) {
        return this._toko.api_url + 'thumb2/' + fotoId
    }

    static getFotoUrl(fotoId) {
        return this._toko.api_url + 'foto/' + fotoId
    }

    static getFotoBarangUrl(fotoBarangId, cabang_id, width) {
        return Api.getBaseUrl() + 'foto_barang/' + (fotoBarangId ? fotoBarangId : -1) + '?cabang_id=' + cabang_id + (width ? '&w=' + width : '')
    }

    static getThumb1Url(fotoId) {
        return this._toko.api_url + 'thumb1/' + fotoId
    }

    static setToko(toko) {
        let base_url = toko.api_url
        this.baseUrlFoto = base_url + 'foto/'
        this.baseUrlThumb1 = base_url + 'thumb1/'
        this.baseUrlThumb2 = base_url + 'thumb2/'
        this._toko = toko
    }

    static getNamaToko() {
        return this.getToko()?.nama
    }

    static getDaftarToko() {
        return this.daftar_toko
        // return config.daftar_toko
    }

    static getTokoById(id) {
        let daftar = this.getDaftarToko()
        return _.find(daftar, { id })
    }

    static getToko() {
        return this._toko
        // return this.getTokoById(config.toko_id)
    }

    static getTokoId() {
        return this.getToko()?.id
    }


    static getShowHargaGrosir() {
        return this.getToko()?.show_harga_grosir
    }

    static getCabangId() {
        return localStorage.getItem("cabang_id")
    }

    static setCabangId(cabangId) {
        localStorage.setItem("cabang_id", cabangId)
    }

    static getBaseUrl() {
        return this.getToko()?.api_url
    }

    static getLogoUrl() {
        let setting = this.getSetting()
        if (setting) {
            return `${Api.getBaseUrl()}file_foto/${setting.file_logo}`
        }
        return null
    }

    static getSidebarUrl() {
        let setting = this.getSetting()
        if (setting) {
            return `${Api.getBaseUrl()}file_foto/${setting.file_sidebar}`
        }
        return null
    }

    static async login(user, password) {
        let api
        try {
            let res = await axios.post(Api.getBaseUrl() + 'login2', {
                user,
                password
            })
            api = res.data
        } catch (er) {
            console.error(er)
        }
        return api
    }

    static isLoggedIn() {
        let token = localStorage.getItem("token") || ""
        return token.length > 0
    }

    static logout() {
        localStorage.setItem("token", "")
    }

    static setToken(token, user) {
        localStorage.setItem("token", token)
        localStorage.setItem("user", user)
    }

    static getUser() {
        return localStorage.getItem("user") || ""
    }

    static isNeedLogin() {
        return Api.getShowHargaGrosir()
    }

    static async getHomeData(cabangId) {
        let api
        try {
            let res = await axios.post(Api.getBaseUrl() + 'home', {
                cabang_id: cabangId
            })
            api = res.data
        } catch (er) {
            console.error(er)
        }
        return api
    }

    static async downloadSetting(cabangId) {
        let ret
        try {
            let res = await axios.post(Api.getBaseUrl() + 'setting', {
                cabang_id: cabangId
            })
            ret = res.data.data
            localStorage.setItem("setting", JSON.stringify(ret))
        } catch (er) {
            console.error(er)
        }
        return ret
    }

    static getSetting() {
        let s = localStorage.getItem("setting");
        if (s) {
            let setting = JSON.parse(s)
            return setting
        }
        return null
    }

    static getBarangBySku(sku) {
        return new Promise((resolve, reject) => {
            axios.post(Api.getBaseUrl() + 'barang', { sku })
                .then(res => {
                    let api = res.data
                    if (!api.ok) {
                        reject(res.msg)
                    }
                    if (!api.data) {
                        reject('Data tidak ditemukan')
                    }
                    resolve(api.data)
                })
                .catch(er => reject(er))
        })
    }

    static async getDaftarBarang(cari, kategori_barang_id, brand_id, skip, take, sort = 'created desc', cabang_id = Api.getCabangId()) {
        let res = await axios.post(Api.getBaseUrl() + 'cari_barang', { cari, kategori_barang_id, brand_id, skip, take, sort, cabang_id })
        return res.data
    }

    static async getDaftarKategori() {
        let res = await axios.post(Api.getBaseUrl() + 'daftar_kategori_barang')
        return res.data
    }

    static async getDaftarFooter(cabang_id) {
        let api = {
            ok: false,
            msg: ''
        }
        let res = await axios.post(Api.getBaseUrl() + 'footers', { cabang_id })
        api = res.data
        return api
    }

    static async getBarang(barang_id) {
        let api = {
            ok: false,
            msg: ''
        }
        let res = await axios.post(Api.getBaseUrl() + 'detail_barang', { barang_id, cabang_id: Api.getCabangId() })
        api = res.data
        return api
    }

    static async getDaftarCabang(toko_id) {
        let ret = []
        let res = await axios.post(Api.getBaseUrl() + 'daftar_cabang', { toko_id })
        ret = res.data
        return ret
    }
}

export default Api